module.exports = __webpack_public_path__ + "img/close.8da7d03c.png";